import { IGpsrTypesItem } from 'redux/reducers/gpsr/types';
import { ETableStructureAlign, ETableStructureType } from 'services/constants/tableStructureTypes';

export const gpsrTypesTableStructure = [
	{
		name: 'ID',
		selector: 'id' as keyof IGpsrTypesItem,
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.LINK,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'Type Name',
		selector: 'name' as keyof IGpsrTypesItem,
		show: true,
		sortable: true,
		filterable: false,
		searchable: true,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Description',
		selector: 'description' as keyof IGpsrTypesItem,
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Number of SKU',
		selector: 'skuCount' as keyof IGpsrTypesItem,
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'Status',
		selector: 'status' as keyof IGpsrTypesItem,
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		filter: [
			['Signed Document', 'Signed Document'],
			['No Document', 'No Document'],
			['Uploaded Document', 'Uploaded Document'],
			['Generated Document', 'Generated Document'],
		],
		colors: [
			['Signed Declaration', 'success.light'],
			['No Declaration', 'error.light'],
			['Declaration Uploaded', 'success.light'],
			['Generated Declaration', 'warning.light'],
		],
		colSpan: 1,
	},
	// {
	// 	name: 'Public Page',
	// 	selector: 'doCLink' as keyof IGpsrTypesItem,
	// 	show: true,
	// 	sortable: false,
	// 	filterable: false,
	// 	type: ETableStructureType.LINK,
	// 	align: ETableStructureAlign.LEFT,
	// 	colSpan: 1,
	// },
	{
		name: 'Actions',
		selector: 'File Report' as keyof IGpsrTypesItem,
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.RIGHT,
		buttons: [{ name: 'Public Page' }],
		colSpan: 1,
	},
];
